import { useRef, useState } from "react";
import { Upload, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { uploadFile } from "@/lib/api";

const inputCls = "w-full bg-background border border-border focus:border-volt outline-none px-3 py-2 text-sm transition-colors duration-200";

const isDirectVideo = (u) => !!u && (/\.(mp4|webm|mov|m4v|ogv)(\?|$)/i.test(u) || u.includes("/api/files/"));

export function ImageInput({ value, onChange, testid, kind = "image", placeholder }) {
  const ref = useRef(null);
  const [busy, setBusy] = useState(false);
  const isVideo = kind === "video";

  const pick = async (e) => {
    const f = e.target.files?.[0];
    if (!f) return;
    setBusy(true);
    try {
      const url = await uploadFile(f);
      onChange(url);
      toast.success(isVideo ? "Video uploaded" : "Image uploaded");
    } catch (err) {
      toast.error("Upload failed");
    } finally {
      setBusy(false);
      if (ref.current) ref.current.value = "";
    }
  };

  const showVideoPreview = isVideo && isDirectVideo(value);

  return (
    <div className="space-y-2">
      <div className="flex gap-2">
        <input className={inputCls} value={value || ""} onChange={(e) => onChange(e.target.value)} placeholder={placeholder || "Paste URL or upload →"} data-testid={testid} />
        <button type="button" onClick={() => ref.current?.click()} disabled={busy}
          className="shrink-0 inline-flex items-center gap-2 border border-border hover:border-volt hover:text-volt px-3 font-mono text-[10px] tracking-[0.15em] uppercase transition-colors duration-200 disabled:opacity-50">
          {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <Upload className="w-4 h-4" />} Upload
        </button>
        <input ref={ref} data-testid={testid ? `${testid}-file` : undefined} type="file" accept={isVideo ? "video/*" : "image/*"} onChange={pick} className="hidden" />
      </div>
      {value && (showVideoPreview
        ? <video src={value} controls className="w-full h-40 object-cover border border-border bg-black" />
        : !isVideo ? <img src={value} alt="" className="w-full h-28 object-cover border border-border" /> : null)}
    </div>
  );
}
